import React from "react";
import { useNavigate } from "react-router";

import Header from "./Header";
import Breadcrumbs from "./Breadcrumbs";
import { ArrowLeftIcon } from "components/Icons";

function Layout({ children, title, back, openModal }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (back) {
      navigate(-1);
      openModal.value = false;
    }
  };

  return (
    <div className="min-h-screen w-screen bg-gray-100">
      <Header />
      <div className="px-4 flex items-center">
        {back && (
          <span>
            <button onClick={handleBack}>
              <ArrowLeftIcon className="size-7" />
            </button>
          </span>
        )}
        {title && <Breadcrumbs title={title} back={back} />}
      </div>
      <main className="max-w-[988px] mx-auto max-md:px-4 pb-5">{children}</main>
    </div>
  );
}

export default Layout;
